export { ServerDownSvg } from "./ServerDownSvg";
export { FloatingSvg } from "./FloatingSvg";
export { TakenSvg } from "./TakenSvg";
export { ResearchSvg } from "./ResearchSvg";
